import React, { useEffect,useState } from "react";
import { Outlet } from "react-router-dom";
import { useNavigate } from "react-router-dom/dist";
import { useAuthContext } from "./AuthDataProvider";

const MainContext = React.createContext(null);

export const useMainContext = () => {
  return React.useContext(MainContext);
};

function MainDataProvider({ children }) {
  const authContext = useAuthContext();
  const navigate = useNavigate();
  const [showAddUser, setShowAddUser] = useState(false);
  const [showAddVessel, setShowAddVessel] = useState(false);
  const [showProjectDetail, setShowProjectDetail] = useState(false);
  const [showAddDownload, setShowAddDownload] = useState(false);
  const [projectMode, setProjectMode] = useState('');
  const [projectId, setProjectId] = useState('');
  const [projectFilter, setProjectFilter] = useState('All');
  const [projectSearchInput, setProjectSearchInput] = useState('');

  const [deviceState, setDeviceState] = useState({
    showDeviceDetail: false,
    deviceMode: '',
    deviceData: {
      deviceid: '',
      devicename: '',
      deviceurl: '',
      vesselid: '',
      vesselname: '',
    },
  });


    useEffect(() => {
    if (authContext.AuthData === null) {
      navigate("/login");
    }
    return () => {};
  }, []);

  const handleAddUser = (status) => {
    setShowAddUser(status)
  };

  const handleAddVessel = (status) => {
    setShowAddVessel(status)
  };

  const handleAddProject = (status) => {
    setShowProjectDetail(status)
  };

  const updateDeviceState = (updatedState) => {
    setDeviceState({
      ...deviceState,
      ...updatedState,
    });
  };

    const handleAddDownload = (status) => {
        setShowAddDownload(status)
    };

  return (
    <MainContext.Provider 
    value={{ 
      HandleAddUser: handleAddUser,
      ShowAddUser: showAddUser,
      HandleAddProject: handleAddProject,
      ShowProjectDetail: showProjectDetail,
      ProjectMode: projectMode,
      SetProjectMode: setProjectMode,
      ProjectId: projectId,
      SetProjectId: setProjectId,
      ProjectFilter: projectFilter,
      SetProjectFilter: setProjectFilter,
      ProjectSearchInput: projectSearchInput,
      SetProjectSearchInput: setProjectSearchInput,
      DeviceState:  deviceState,
      UpdateDeviceState: updateDeviceState,
      HandleAddVessel: handleAddVessel,
      ShowAddVessel: showAddVessel,
      HandleAddDownload: handleAddDownload,
      ShowAddDownload: showAddDownload
    }}>
      <Outlet />
    </MainContext.Provider>
  );
}

export default MainDataProvider;
